export default "__VITE_ASSET__881ab949__"